// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__pRo-O","inputWrap":"CustomTip_inputWrap__1LaEU"};